module.exports = __webpack_public_path__ + "img/subs-meat.d5fa1d2f.png";